import { Requester } from './Requester';

export const GetHasActiveSurvey = async (clientId: string): Promise<boolean> => {
    try {
        const response = await Requester<{ hasActiveSurveys: boolean }>({
            path: `organizations/${clientId}/surveys/hasActive`,
            method: 'GET'
        });

        return 'hasActiveSurveys' in response ? response.hasActiveSurveys : false;
    } catch (e) {
        console.error('Get contact request failed');
        return Promise.reject(e);
    }
};
